import { useContext } from 'react';
import BreadcrumbContext from '../../contexts/BreadcrumbContext';

const useBreadcrumbContext = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumbContext must be used within BreadcrumbContextProvider!');
  }
  return context;
};

export default useBreadcrumbContext;
